/**
 * 사이드바 글쓰기 버튼 컴포넌트 - Tabs 스타일 버전
 */ import React from 'react';
import { Button, cn } from '@heroui/react';
import { motion } from 'framer-motion';
import * as m from "@paraglide/messages";
import { Pen as PenLine } from 'lucide-react';
import { TWEET_COMPOSER_TEST_IDS } from '@edusense/shared-constants';
export const WriteButtonTabs = ({ showWriteButton, onWriteButtonClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    if (!showWriteButton || !onWriteButtonClick) {
        return null;
    }
    const shouldUseIconOnly = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    const iconVariants = {
        inactive: {
            scale: 1,
            rotate: 0
        },
        hover: {
            scale: 1.15,
            rotate: [
                0,
                -10,
                10,
                0
            ],
            transition: {
                rotate: {
                    duration: 0.4,
                    times: [
                        0,
                        0.25,
                        0.75,
                        1
                    ]
                },
                scale: {
                    duration: 0.2,
                    type: "spring",
                    stiffness: 300
                }
            }
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: cn("w-full p-3 relative", isMobileSidebar ? "px-3" : "px-4")
    }, /*#__PURE__*/ React.createElement(Button, {
        color: "primary",
        variant: "shadow",
        size: "lg",
        "data-testid": TWEET_COMPOSER_TEST_IDS.COMPOSE_TRIGGER,
        onPress: onWriteButtonClick,
        className: cn("w-full h-12 relative", "bg-gradient-to-r from-primary to-primary-600", "hover:from-primary-600 hover:to-primary-700", "transition-all duration-300 ease-in-out", "shadow-lg hover:shadow-xl", "font-semibold", shouldUseIconOnly && "px-3")
    }, /*#__PURE__*/ React.createElement(motion.div, {
        className: cn("flex items-center gap-3 w-full", isMobileSidebar ? "justify-start" : shouldUseIconOnly ? "justify-center" : "justify-end"),
        initial: "inactive",
        whileHover: "hover"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        variants: iconVariants,
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ React.createElement(PenLine, {
        size: 20
    })), !shouldUseIconOnly && /*#__PURE__*/ React.createElement(motion.span, {
        className: "font-medium text-white",
        initial: {
            opacity: 0.9
        },
        whileHover: {
            opacity: 1
        }
    }, m.common_edit()))));
};
export default WriteButtonTabs;
